import clsx from 'clsx'
import { observer } from 'mobx-react'
import * as React from 'react'

import { Icon } from '@/component/atoms/Icon'
import type { StyleProps } from '@/types'

import NumericInput from '../Input/NumericInput'
import S from './PlusMinusInput.style'

type Props = {
  min?: number
  max?: number
  value: number
  onChange: (value: number) => void
  extraText?: React.ReactNode
  disabled?: boolean
  unit?: number
  name?: string
} & StyleProps &
  (
    | {
        editable?: false
        children?: React.ReactNode
      }
    | {
        editable: true
        children?: never
      }
  )

const PlusMinusInput = ({
  unit = 1,
  min = 1,
  max = 5,
  value,
  onChange,
  extraText,
  style,
  className,
  disabled,
  name,
  editable = false,
  children,
}: Props) => {
  return (
    <div css={S} className={className} style={style}>
      <button
        type="button"
        className="dec-button"
        aria-label="수량 감소"
        onClick={() => onChange(value - unit)}
        disabled={value <= min || disabled}
      >
        <Icon name="remove" color="var(--Colors-Gray-500)" />
      </button>
      {children ? (
        children
      ) : editable ? (
        <NumericInput
          className="problem-count-input"
          value={value}
          disabled={disabled}
          min={min}
          max={max}
          onChange={(e) => {
            onChange(Number(e.target.value))
          }}
          onBlur={(e) => {
            if (Number(e.target.value) < min) {
              onChange(min)
            }
            if (Number(e.target.value) > max) {
              onChange(max)
            }
          }}
        />
      ) : (
        <span className={clsx('problem-count', disabled && 'disabled')}>{value}</span>
      )}
      <button
        type="button"
        className="inc-button"
        aria-label="수량 증가"
        onClick={() => onChange(value + unit)}
        disabled={value >= max || disabled}
      >
        <Icon name="add" color="var(--Colors-Gray-500)" />
      </button>
      {extraText}
      <input className="input" type="number" name={name} value={value} readOnly />
    </div>
  )
}

export default observer(PlusMinusInput)
